import { Currency } from "@freightsimple/generated-dashboard-openapi-client/models/Currency";
import { createEnumDropdown } from "@freightsimple/ui-core/Controls/EnumDropdown";
import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { CreateAccountErrorMessages } from "@/Shared/Authentication/Hooks/useAuthenticationCreateAccount";
import { AccountType } from "@/Shared/Authentication/Hooks/useAuthenticationCreateAccount";

const CurrencySelect = createEnumDropdown<Currency>(Currency, (c) => c);

const SHIPMENT_FREQUENCY_OPTIONS = [
  { value: "Daily", label: "Most days" },
  { value: "Weekly", label: "Most weeks" },
  { value: "Occasional", label: "Occasionally" },
  { value: "SingleShipment", label: "Single Shipment" },
];

interface CreateAccountPageCompanyDetailsProps {
  accountType: AccountType | undefined;
  isPersonalSelected: boolean | undefined;
  companyName: string;
  setCompanyName: (_: string) => void;
  companyCurrency: Currency | undefined;
  setCompanyCurrency: (_: Currency) => void;
  shipmentFrequency: string | undefined;
  setShipmentFrequency: (_: string) => void;
  forceValidation: boolean;
  errorMessages: CreateAccountErrorMessages;
}

export function AuthenticationCreateAccountPageCompanyDetails(
  props: CreateAccountPageCompanyDetailsProps,
) {
  const {
    accountType,
    isPersonalSelected,
    companyName,
    setCompanyName,
    companyCurrency,
    setCompanyCurrency,
    shipmentFrequency,
    setShipmentFrequency,
    forceValidation,
    errorMessages,
  } = props;

  if (accountType === undefined) {
    return <></>;
  }

  return (
    <ShowFormErrors show={forceValidation}>
      <Stack gap={5}>
        {!isPersonalSelected && (
          <>
            <FormItem
              label="Company name"
              fillWidth
              emphasizeLabel
              error={errorMessages.companyName}
            >
              <TextInput
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                autoComplete="organization"
                name="signup_company_name"
                width="full"
                placeholder="Enter company name"
              />
            </FormItem>
            <FormItem
              label="How often do you ship LTL freight?"
              fillWidth
              emphasizeLabel
              error={errorMessages.shipmentFrequency}
            >
              <Dropdown
                options={SHIPMENT_FREQUENCY_OPTIONS}
                value={shipmentFrequency}
                onChange={setShipmentFrequency}
                placeholder="Select"
                width="full"
                data-testid="signup-shipment-frequency"
              />
            </FormItem>
          </>
        )}
        <FormItem
          label="What is your billing currency?"
          fillWidth
          emphasizeLabel
          error={errorMessages.companyCurrency}
        >
          <CurrencySelect
            value={companyCurrency}
            onChange={(currency) => {
              if (currency) {
                setCompanyCurrency(currency);
              }
            }}
            placeholder="Select"
            data-testid="signup-currency"
          />
        </FormItem>
      </Stack>
    </ShowFormErrors>
  );
}
